import React, { useEffect } from "react";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { updatePartnerDetails } from "../../../slices/partner/action";
import { useDispatch } from "react-redux";
import { alertError, alertSuccess } from "../../../helpers/errorHandling";
const BillingInfoForm = ({ partnerDetails, handleUpdate }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(false);

  const validation = useFormik({
    initialValues: {
      companyName: "",
      address: "",
      trn: "",
      paymentTerms: "",
      bankName: "",
      bankAccount: "",
    },
    validationSchema: Yup.object({
      companyName: Yup.string().required("Please Enter Company Name"),
      address: Yup.string().required("Please Enter Address"),
      trn: Yup.string().required("Please Enter TRN"),
      paymentTerms: Yup.string().required("Please Enter Payment Terms"),
      bankName: Yup.string().required("Please Enter Bank Name"),
      bankAccount: Yup.string().required("Please Enter Bank Account"),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const res = await updatePartnerDetails(
          { billingInfo: { ...values } },
          dispatch
        );

        if (res?._id) {
          alertSuccess("Updated Successfully");
        } else {
          alertError({ message: "Failed, Please try again" });
        }

        handleUpdate();
        setTimeout(() => {
          setIsLoading(false);
        }, 1500);
      } catch (e) {
        console.log(e);
      }
    },
  });

  useEffect(() => {
    if (partnerDetails?.billingInfo) {
      const { billingInfo } = partnerDetails;
      validation.setValues({
        companyName: billingInfo?.companyName || "",
        address: billingInfo?.address || "",
        trn: billingInfo?.trn || "",
        paymentTerms: billingInfo?.paymentTerms || "",
        bankName: billingInfo?.bankName || "",
        bankAccount: billingInfo?.bankAccount || "",
      });
    }
  }, [partnerDetails]);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
      }}
    >
      <Row>
        <Col md={12} className="mb-3">
          <Label>Company Name</Label>
          <Input
            name="companyName"
            placeholder="Enter Company Name"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.companyName}
            invalid={
              validation.touched.companyName && !!validation.errors.companyName
            }
          />
          <FormFeedback>{validation.errors.companyName}</FormFeedback>
        </Col>

        <Col md={12} className="mb-3">
          <Label>Address</Label>
          <Input
            name="address"
            placeholder="Enter Address"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.address}
            invalid={validation.touched.address && !!validation.errors.address}
          />
          <FormFeedback>{validation.errors.address}</FormFeedback>
        </Col>

        <Col md={12} className="mb-3">
          <Label>TRN</Label>
          <Input
            name="trn"
            placeholder="Enter TRN"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.trn}
            invalid={validation.touched.trn && !!validation.errors.trn}
          />
          <FormFeedback>{validation.errors.trn}</FormFeedback>
        </Col>

        <Col md={12} className="mb-3">
          <Label>Payment Terms</Label>
          <Input
            name="paymentTerms"
            placeholder="Enter Payment Terms"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.paymentTerms}
          />
        </Col>

        <Col md={12} className="mb-3">
          <Label>Bank Name</Label>
          <Input
            name="bankName"
            placeholder="Enter Bank Name"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.bankName}
          />
        </Col>

        <Col md={12} className="mb-3">
          <Label>Bank Account</Label>
          <Input
            name="bankAccount"
            placeholder="Enter Bank Account"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.bankAccount}
          />
        </Col>
      </Row>

      <Button
        color="primary"
        type="submit"
        className="w-auto"
        disabled={isLoading}
        size="sm"
      >
        {isLoading ? <Spinner size="sm" /> : "Save"}
      </Button>
    </Form>
  );
};

export default BillingInfoForm;

BillingInfoForm.propTypes = {
  partnerDetails: PropTypes.object,
  handleUpdate: PropTypes.func.isRequired,
};
